let GA_MEASUREMENT_IDS = ['G-FKL4G9VWST']

const tagAll = (func: (id: string) => any) =>
  GA_MEASUREMENT_IDS.map(id => func(id))

export default class GoogleAnalytics {
  static init(
    userId: number | null | undefined,
    _businessName: string | null | undefined,
    ids?: string[] | null | undefined,
  ) {
    if (!window.gtag) return
    if (ids) GA_MEASUREMENT_IDS = ids
    tagAll(GA_MEASUREMENT_ID =>
      window.gtag('config', GA_MEASUREMENT_ID, {
        user_id: userId ? String(userId) : undefined,
        send_page_view: false,
      }),
    )
  }

  static reset() {
    // we don't reset business dimension here
    if (!window.gtag) return
    tagAll(GA_MEASUREMENT_ID =>
      window.gtag('config', GA_MEASUREMENT_ID, {
        user_id: null,
      }),
    )
  }

  static sendPageview() {
    if (typeof __DEBUG__ !== 'undefined' && __DEBUG__) {
      console.log(
        'ga set page',
        window.location.pathname + window.location.search,
      )
      return
    }

    if (!window.gtag) return
    tagAll(GA_MEASUREMENT_ID =>
      window.gtag('event', 'page_view', {
        send_to: GA_MEASUREMENT_ID,
        page_path: window.location.pathname + window.location.search,
        page_location: window.location.href,
        page_title: document.title,
      }),
    )
  }

  // note that not all timing events will be processed, check Sampling
  // consederations here:
  // https://developers.google.com/analytics/devguides/collection/analyticsjs/user-timings
  static sendEventTiming(
    category: string,
    event: string,
    timingValue: number,
    label: string,
  ): void {
    if (!window.gtag) return
    tagAll(GA_MEASUREMENT_ID =>
      window.gtag('event', 'timing_complete', {
        name: event,
        value: timingValue,
        event_category: category,
        event_label: label,
        send_to: GA_MEASUREMENT_ID,
      }),
    )
  }

  // note that not all events will be tracked, see
  // https://support.google.com/analytics/answer/1033068#Implementation
  static sendEvent(
    category: string,
    event: string,
    value?: string | number,
    label?: string,
  ) {
    if (typeof __DEBUG__ !== 'undefined' && __DEBUG__) {
      console.log('ga', 'send', 'event', category, event, value, label)
      return
    }

    if (!window.gtag) return
    tagAll(GA_MEASUREMENT_ID =>
      window.gtag('event', event, {
        event_category: category,
        event_label: label,
        value: value,
        send_to: GA_MEASUREMENT_ID,
      }),
    )
  }
}
